import * as React from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import Sticky from "react-stickynode";
import Helmet from "react-helmet";
import { createSelector } from "reselect";
import $ from "jquery";
import debounce from "lodash/debounce";
import uniq from "lodash/uniq";
import uniqby from "lodash/uniqBy";
import upperFirst from "lodash/upperFirst";
import reduce from "lodash/reduce";
import isEqual from "lodash/isEqual";
import { color, timing, zIndex } from "rizzo-next/sass/settings.json";
import shallowCompare from "react-addons-shallow-compare";
import capitalize from "lodash/capitalize";
import { connect } from "react-redux";
import { animateScroll } from "react-scroll";
import { Style } from "radium";
import Waypoint from "react-waypoint";
import assign from "object-assign";
import {
  analytics,
  ApplicationNames,
  createDataLayerScript,
  DataLayerInitializer,
  DestinationDirectories,
  DestinationSubNavs,
  SiteSections,
  TrackingContainersInitializer,
} from "@lonelyplanet/lp-analytics";
import actions from "../actions";
import poiActions from "../../pois/actions";
import Breadcrumbs from "../../pois/components/breadcrumbs";
import { connected as ListItems } from "./listItems";
import { connected as Booking } from "../../pois/components/booking";
import SidebarSection from "../../pois/components/sidebarSection";
import Button from "../../pois/components/button";
import Takeover from "../../pois/components/takeover";
import TypeSelector from "./typeSelector";
import Dropdown from "../../pois/components/dropdown";
import Filter from "./filter";
import MobileToolbar from "./mobileToolbar";
import NoResults from "./noResults";
import listItemTypes from "../listItemTypes";
import { poiTypes } from "../../../../server/lib/open-planet/poiTypes";
import createMetaData from "../../../../server/lib/helpers/metaData";
import resourceTypes from "../../../../server/lib/open-planet/resourceTypes";
import getAvailability from "../../pois/selectors/getAvailability";
import selectDates from "../../shared/actions/selectDates";
import { pageView } from "../../shared/actions/analytics";
import constants from "../../shared/constants";
import { LIST_RENDER } from "../constants";
import buildPlaceDimensions from "../../shared/udo/buildPlaceDimensions";
import { createListUrl } from "../../../../server/utils/createUrls";
import DataLayer from "../../shared/components/dataLayer";
import {
  RESOURCE_MAP,
  RESOURCE_KIND_MAP,
} from "../../../../server/routes/constants";

import {
  uniquePois,
  mapCenter,
  getSubtypes,
  getFacilities,
  getNeighborhoods,
} from "../../list/selectors";

const _ = { debounce, uniq, uniqby, upperFirst, reduce, capitalize, isEqual };

const shouldFetchSubtypes = resource => resource !== resourceTypes.lodging &&
  resource !== resourceTypes.collections;

let InteractiveMap;

if (typeof window !== "undefined") {
  /* eslint-disable */
  InteractiveMap = require("../../pois/components/interactiveMap").connected;
  /* eslint-enable */
}

const styles = {
  header: {
    dropdown: {
      desktop: {
        float: "right",
        marginTop: "15px",
      },
      mobile: {
        position: "absolute",
        right: 0,
        top: "12px",
      },
    },
  },
  mobile: {
    toolbar: {
      paddingBottom: "20px",
      paddingLeft: "18px",
      paddingRight: "18px",
      paddingTop: "24px",
    },
  },
};

/**
 * Renders a list of pois
 * @augments React.Component<ListComponentProps, ListComponentState>
 */
export default class ListComponent extends React.Component {
  static propTypes = {
    /**
     * The breadcrumbs for this component
     */
    breadcrumb: PropTypes.array.isRequired,
    /**
     * Dispatch from the store
     */
    dispatch: PropTypes.func,
    /**
     * Is the component loading
     */
    loading: PropTypes.bool,
    /**
     * POIs to display
     */
    pois: PropTypes.array,
    /**
     * A list of parameters for the POI
     */
    params: PropTypes.object,
    /**
     * Whether or not the layout should be formatted for mobile screen sizes
     */
    mobile: PropTypes.object,
    /**
     * Center point for the map
     */
    mapCenter: PropTypes.array,
    /**
     * Link for the next set of list items
     */
    nextPoisLink: PropTypes.string,
    /**
    * Array of subtypes
    */
    subtypes: PropTypes.array,
    /**
    * Place object
    */
    place: PropTypes.object,
    /**
    * Array of amenities
    */
    facilities: PropTypes.array,
    /**
     * Availability for lodgings
     */
    availability: PropTypes.object,
    /**
     * Is the list fetching the next for infinite scroll
     */
    fetchingNext: PropTypes.bool,
    /**
     * filters
     */
    filters: PropTypes.object,
    /**
     * Open Planet resource type
     */
    resource: PropTypes.string,
    /**
     * String of which PoiType or Activity or Tour
     */
    kind: PropTypes.string,
    /**
     * Array of favorites
     */
    favorites: PropTypes.object,
    /**
     * Array of images
     */
    images: PropTypes.array,
  }

  static _isRestaurant() {
    return false;
    // TODO: Uncomment when price filtering is ready
    // return `pois/${this.props.resource}` === listItemTypes.eating.slug;
  }

  static hasQueryChanged(qsFilters, filters) {
    // Need to get filters out that only equal true
    const onFilters = Object.keys(filters).reduce((m, filter) => {
      const newFilter = {};
      Object.keys(filters[filter]).forEach(k => {
        if (filters[filter][k]) {
          newFilter[k] = filters[filter][k];
        }
      });

      if (Object.keys(newFilter).length) {
        m[filter] = newFilter;
      }

      return m;
    }, {});

    return !_.isEqual(qsFilters, onFilters);
  }

  constructor(props) {
    super(props);

    this.state = {
      renderMap: false,
      totalPois: props.pois.length,
      pois: props.pois,
      currency: "USD",
      dateRange: [],
      dateRangeString: "",
      priceRange: [],
      windowWidth: 0,
      adLeft: 0,
      adWidth: 0,
    };

    this.page = 1;
    this.mapMode = "hover";
    this.adThreshold = 1079;

    [
      "markerClick",
      "markerClickMobile",
      "_handleWaypointEnter",
      "updateDimensionsForAd",
      "toggleFilter",
      "rangeFilter",
      "resetDates",
      "showListPrices",
      "onSelectDates",
      "priceSliderProps",
      "durationSliderProps",
      "handleToolbarClick",
    ].forEach(fn => {
      this[fn] = this[fn].bind(this);
    });
  }

  // Will fire after coming back from a POI detail page
  componentDidMount() {
    const {
      dispatch,
      pois,
      place,
      subtypes,
      resource,
      kind,
      filters,
    } = this.props;

    // User came in from detail page and clicked on a list link
    if (!pois.length) {
      dispatch(
        actions.fetchList({
          resource,
          id: place.id,
          filters: this.props.filters,
        })
      );
    }

    if (!subtypes.length) {
      if (shouldFetchSubtypes(resource)) {
        dispatch(
          actions.fetchSubtypes({
            id: place.id,
            resource,
            kind,
          })
        );
      }
    }

    if (window.innerWidth > this.adThreshold) {
      this.updateDimensionsForAd();
      window.addEventListener(
        "resize",
        _.debounce(this.updateDimensionsForAd, 250)
      );
    }

    this._initMap();
    dispatch(actions.initList(pois, place, kind, resource, filters, dispatch));
  }

  // Will fire after you choose a new type from the type selector
  componentWillReceiveProps(nextProps) {
    const { params, pois: nextPois, resource, kind } = nextProps;
    const { id, poiType } = params;
    const { dispatch, place } = this.props;

    if (this._hasResourceChanged(resource, kind)) {
      dispatch(
        actions.fetchNextList({
          id,
          resource,
          filters: {},
        })
      );

      if (shouldFetchSubtypes(resource)) {
        dispatch(
          actions.fetchSubtypes({ id: place.id, poiType, resource, kind })
        );
      }
    }

    // After we get back from the fetchNextList we need to tell the component it has moar pois now
    const isInfiniteScrolling = nextPois.length !== this.props.pois.length;

    if (isInfiniteScrolling) {
      this.setState({
        totalPois: nextPois.length,
      });
    }
  }

  shouldComponentUpdate(
    nextProps,
    nextState
  ) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps) {
    const { dispatch } = this.props;
    const resourceChanged = this.props.resource !== prevProps.resource;
    const kindChanged = this.props.kind !== prevProps.kind;
    const isUrlUpdated = kindChanged || resourceChanged;

    if (this.props.pois.length > 0 && isUrlUpdated) {
      dispatch(pageView(LIST_RENDER));
    } else if (prevProps.pois.length === 0 && this.props.pois.length > 0) {
      dispatch(pageView(LIST_RENDER));
    }
  }

  componentWillUnmount() {
    if (window.innerWidth > this.adThreshold) {
      window.removeEventListener("resize", this.updateDimensionsForAd);
    }

    this.props.dispatch(actions.clearList());
  }

  onSelectDates({ startDate, endDate, numNights }) {
    this.props.dispatch(selectDates({ startDate, endDate, numNights }));

    if ((startDate && endDate) || (!startDate && !endDate)) {
      this.toggleFilter({
        filterType: "booking",
        name: "dates",
        checked: {
          startDate,
          endDate,
          numNights,
        },
      });
    }
  }

  _initMap() {
    // Avoid layout thrashing with this...
    this.setState({
      renderMap: true,
    });
  }

  _hasResourceChanged(nextResource, nextKind) {
    const currentResource = this.props.resource;
    const currentKind = this.props.kind;

    return nextResource !== currentResource || nextKind !== currentKind;
  }

  _shouldFetchNext(
    fetchingNext,
    pois,
    nextPoisLink
  ) {
    return !fetchingNext && this.state.totalPois >= pois.length && nextPoisLink;
  }

  _isLodging() {
    return this.props.resource === resourceTypes.lodging;
  }

  _isTour() {
    return this.props.kind === listItemTypes.tours.kind;
  }

  _isActivity() {
    return this.props.kind === listItemTypes.activities.kind;
  }

  _isCollection() {
    return this.props.kind === listItemTypes.collections.kind;
  }

  _handleWaypointEnter({ event }) {
    const {
      dispatch,
      pois,
      params,
      nextPoisLink,
      fetchingNext,
      resource,
    } = this.props;

    // The first time the component loads the waypoint triggers with an empty event
    // This makes sure to not accidentally re-fetch data on first mount coming from lists
    if (!event) return;

    // Once we've gotten through 10 POIs, load the next 10
    if (this._shouldFetchNext(fetchingNext, pois, nextPoisLink)) {
      dispatch(
        actions.fetchNextList({
          id: params.id,
          resource,
          url: nextPoisLink,
          filters: this.props.filters,
        })
      );

      this.page += 1;

      dispatch(actions.infiniteScroll(this.page));
    }

    // We reached the bottom of an POI, so we're about to render another one
    this.setState({
      totalPois: (this.state.totalPois += pois.length),
    });
  }

  showListPrices() {
    if (this.props.mobile.isMobile) {
      this.props.dispatch(
        actions.toggleTakeover(constants.OPEN_FILTER_TAKEOVER)
      );

      // Needs to wait:
      // 1. for the Takeover animation to finish, and
      // 2. for the Takeover to reach its final position so that the DateRange
      //    tether attaches to the correct position (and not the bottom of the
      //    window)
      setTimeout(() => {
        this.props.dispatch(actions.showPrices(true));
      }, 800);
    } else {
      this.props.dispatch(actions.showPrices(true));
    }
  }

  markerClick(event, poi, params) {
    const position = $(`#poi-${poi.id}`).offset().top + 1;

    if (!poi.location) return;

    this.props.dispatch(poiActions.hoverPlace(assign({}, poi, { params })));

    animateScroll.scrollTo(position, {
      duration: 1000,
      smooth: true,
    });
  }

  markerClickMobile(event, poi, params) {
    if (!poi.location) return;

    this.props.dispatch(poiActions.hoverPlace(assign({}, poi, { params })));
  }

  updateDimensionsForAd() {
    this.setState({
      windowWidth: window.innerWidth,
      adLeft: (window.innerWidth - document.querySelector(".PageContainer").offsetWidth) / 2,
      adWidth: ((window.innerWidth - document.querySelector(".PageContainer").offsetWidth) / 2)
        + 30 + document.querySelector(".PageArticle").offsetWidth,
    });
  }

  resetDates() {
    this.onSelectDates({
      startDate: "",
      endDate: "",
      numNights: null,
    });
  }

  toggleFilter({ name, value, checked, filterType, reset } = {}) {
    const { dispatch, params, resource } = this.props;
    const { id } = params;
    let filters = Object.assign({}, this.props.filters);

    if (filterType) {
      filters[filterType] = filters[filterType] || {};
      filters[filterType][value || name] = checked;
    }

    if (reset) {
      if (reset === "all") {
        filters = {};
      } else {
        filters[reset] = {};
      }
    }

    dispatch(
      actions.filterList({
        id,
        resource,
        filters,
      })
    );
  }

  rangeFilter({ range, type, reset }) {
    const { dispatch, params, resource } = this.props;
    const { id } = params;
    const filters = Object.assign({}, this.props.filters);

    if (type) {
      filters[type] = { range };
    }

    if (reset) {
      Object.keys(filters).forEach(f => {
        filters[f] = false;
      });
    }

    dispatch(
      actions.filterList({
        id,
        resource,
        filters,
      })
    );

    document.body.scrollTop = 0;
  }

  priceSliderProps(filters) {
    let values = [];

    if (filters.price) {
      values = [filters.price.range[0], filters.price.range[1]];
    } else {
      values = this._isTour() || this._isLodging() ? [10, 5000] : [10, 1000];
    }

    return {
      type: "slider",
      changeRange: (e) =>
        this.rangeFilter({ range: e, type: "price" }),
      label: "Filter by price",
      price: true,
      defaultValue: values,
      min: 10,
      max: this._isTour() || this._isLodging() ? 5000 : 1000,
    };
  }

  durationSliderProps(filters) {
    let values = [];

    if (filters.duration) {
      values = [filters.duration.range[0], filters.duration.range[1]];
    } else {
      values = this._isTour() ? [3 * 24, 30 * 24] : [0, 3 * 24];
    }

    return {
      type: "slider",
      changeRange: (e) =>
        this.rangeFilter({ range: e, type: "duration" }),
      label: "Filter by duration",
      time: true,
      defaultValue: values,
      min: this._isTour() ? 3 * 24 : 0,
      max: this._isTour() ? 30 * 24 : 3 * 24,
    };
  }

  handleToolbarClick(type) {
    this.props.dispatch(actions.toggleTakeover(type));
  }

  placeName(type) {
    const { place } = this.props;
    const types = [].concat(type);
    return (place && types.indexOf(place.placeType) > -1 && place.name) || undefined;
  }

  renderSliders(filters) {
    const priceSliderProps = this.priceSliderProps(filters);
    const durationSliderProps = this.durationSliderProps(filters);

    return (
      <div>
        <SidebarSection title="Price Range" contentType="slider">
          <Filter {...priceSliderProps} />
        </SidebarSection>

        <SidebarSection
          title="Duration"
          contentType="slider"
          modifier="priceRange"
        >
          <Filter {...durationSliderProps} />
        </SidebarSection>
      </div>
    );
  }

  renderLodgingSliders({ type, filters }) {
    const { mobile } = this.props;

    return (
      <div>
        <SidebarSection
          title="Price Range"
          contentType="slider"
          modifier="priceRange"
        >
          {mobile.isMobile &&
            type.showCurrency &&
            false &&
            <div style={styles.header.dropdown.mobile}>
              <Dropdown
                options={["AUD", "EUR", "GBP", "USD"]}
                defaultValue={this.state.currency}
                size="small"
                onChange={event => {
                  this.setState({
                    currency: event.currentTarget.value,
                  });
                }}
              />
            </div>}

          <Filter {...this.priceSliderProps(filters)} />
        </SidebarSection>
      </div>
    );
  }

  render() {
    const {
      pois,
      mobile,
      breadcrumb,
      subtypes,
      params,
      loading,
      facilities,
      availability,
      fetchingNext,
      filters,
      kind,
      resource,
      place,
      images,
    } = this.props;

    const neighborhoods = getNeighborhoods(place);

    const { windowWidth, adLeft, adWidth } = this.state;

    const asideClassName = kind === poiTypes.sleeping.name
      ? "PageAside"
      : "PageAside PageAside--padded";

    const menuItems = Object.keys(listItemTypes)
      .filter(key => !listItemTypes[key].hide)
      .map(key => ({
        item: listItemTypes[key].title,
        slug: createListUrl({
          breadcrumb: breadcrumb.map(b => b.title),
          kind: listItemTypes[key].kind,
          resource: listItemTypes[key].resource,
          placeId: params.placeId,
        }),
      }));

    const type = listItemTypes[kind] || listItemTypes[resource];

    const adWrapperStyle = {
      left: windowWidth > this.adThreshold
        ? `-${(adLeft / windowWidth) * 100}vw`
        : 0,
      position: "relative",
      textAlign: "right",
      width: windowWidth > this.adThreshold
        ? `${(adWidth / windowWidth) * 100}vw`
        : "100%",
    };

    const loadingStyle = loading
      ? { opacity: "0.4", transition: "0.2s opacity" }
      : { opacity: "1", transition: "0.2s opacity" };

    subtypes.forEach(s => {
      const subtype = s;
      subtype.checked = filters.subtypes && filters.subtypes[s.name];
    });

    facilities.forEach(a => {
      const amenity = a;
      amenity.checked = filters.facilities && filters.facilities[a.name];
    });

    neighborhoods.forEach(n => {
      const neighborhood = n;

      neighborhood.checked = filters.locations && filters.locations[n.value];
    });

    const lpReview = [
      {
        name: "Lonely Planet reviewed",
        value: "lp_review",
        checked: filters.exists && filters.exists.lp_review,
      },
    ];

    const sliders = this.renderSliders(filters);
    const lodgingSliders = this.renderLodgingSliders({ type, filters });

    const poiLocations = this.props.pois.reduce((memo, p) => {
      if (p.lodging && p.lodging.location) {
        memo.push(p.lodging);
      } else if (p.location) {
        memo.push(p);
      }

      return memo;
    }, []);

    const meta = createMetaData({ items: pois, kind, resource }, place, "list");
    const destinationSubNav = (() => {
      switch (resource) {
        case resourceTypes.partner_activity:
          return DestinationSubNavs.activities;
        case resourceTypes.lodging:
          return DestinationSubNavs.hotels;
        case resourceTypes.narrative:
        case resourceTypes.narratives:
          return DestinationSubNavs.narratives;
        case resourceTypes.articles:
          return DestinationSubNavs.articles;
        case resourceTypes.poi:
          return DestinationSubNavs.experiences;
        default:
          return resource;
      }
    })();
    return (
      <div className="PageContainer">
        <DataLayerInitializer
          script={createDataLayerScript({
            [analytics.applicationName]: ApplicationNames.dotcomPois,
            [analytics.atlasId]: place && place.id,
            [analytics.contentContinent]: this.placeName("continent"),
            [analytics.contentCountry]: this.placeName("country"),
            [analytics.contentCity]: this.placeName("city"),
            [analytics.contentNeighborhood]: this.placeName(["neighborhood", "neighbourhood"]),
            [analytics.contentRegion]: this.placeName("region"),
            [analytics.destinationDirectory]: DestinationDirectories.poiList,
            [analytics.destinationSubNav]: destinationSubNav,
            [analytics.hasPhoto]: images && images.length > 0,
            [analytics.siteSection]: SiteSections.destinations,
          })}
          helmet
        />
        <TrackingContainersInitializer helmet />
        <Helmet
          title={meta.title}
          description={meta.description}
          link={[
            {
              rel: "canonical",
              href: meta.canonical,
            },
          ]}
          meta={[
            { name: "title", content: meta.title },
            { name: "description", content: meta.description },
            { property: "og:title", content: meta.title },
            { property: "og:description", content: meta.description },
            { name: "title", class: "swiftype", "data-type": "string", content: meta.title },
            { name: "op-type", class: "swiftype", "data-type": "string", content: "poi-list" },
            { name: "op-id", class: "swiftype", "data-type": "string", content: place.id },
            { name: "body", class: "swiftype", "data-type": "text", content: meta.description },
            { name: "op-parent-id", class: "swiftype", "data-type": "text", content: place.id },
            { name: "op-parent-name", class: "swiftype", "data-type": "text", content: place.name },
            { name: "op-subtype", class: "swiftype", "data-type": "string", content: type.title },
            { name: "op-type-poi-list", class: "swiftype", "data-type": "integer", content: "100" },
          ]}
        />
        <DataLayer
          data={{
            content_group_2: "lists",
            kind,
            resource,
            ...buildPlaceDimensions(place),
          }}
        />

        {!mobile.isMobile && <Breadcrumbs links={breadcrumb} />}

        <div className="Page Page--list">
          <div className="PageContent">
            {!mobile.isMobile &&
              <aside className={asideClassName}>
                <Sticky
                  enabled={!mobile.isMobile}
                  top={30}
                  bottomBoundary=".PageContent"
                >
                  {(this._isTour() || this._isActivity()) && sliders}

                  {this._isLodging() &&
                    <SidebarSection
                      title="Check availability"
                      contentType="booking"
                      first
                    >
                      <Booking
                        type="hotel"
                        startDate={availability.startDate}
                        endDate={availability.endDate}
                        filter
                        onSelectDates={this.onSelectDates}
                      />
                    </SidebarSection>}

                  {this._isLodging() &&
                    availability.startDate &&
                    availability.endDate &&
                    lodgingSliders}

                  {ListComponent._isRestaurant() &&
                    <SidebarSection title="Price">
                      <Filter
                        filters={["$", "$$", "$$$"]}
                        type="checkbox"
                        columns={3}
                      />
                    </SidebarSection>}

                  {subtypes.length > 0 &&
                    !this._isCollection() &&
                    <SidebarSection title="Type" contentType="checkboxes">
                      <Filter
                        filters={subtypes}
                        type="checkbox"
                        onChange={args =>
                          this.toggleFilter({
                            ...args,
                            filterType: "subtypes",
                          })}
                        onSelectNone={() => {
                          this.toggleFilter({ reset: "subtypes" });
                        }}
                        limit={10}
                        modifier="subtypes"
                      />

                      {this._isLodging() &&
                        <Filter
                          filters={lpReview}
                          type="checkbox"
                          onChange={args =>
                            this.toggleFilter({
                              ...args,
                              filterType: "exists",
                            })}
                          columns={1}
                          modifier="reviewed"
                          noMargin
                        />}
                    </SidebarSection>}

                  {this._isLodging() &&
                    <SidebarSection title="Amenities" collapsed>
                      <Filter
                        filters={facilities}
                        type="checkbox"
                        onChange={args =>
                          this.toggleFilter({
                            ...args,
                            filterType: "facilities",
                          })}
                        columns={2}
                        space
                      />
                    </SidebarSection>}

                  {neighborhoods.length > 0 &&
                    !this._isTour() &&
                    !this._isActivity() &&
                    !this._isCollection() &&
                    <SidebarSection title="Neighborhoods" collapsed>
                      <Filter
                        filters={neighborhoods}
                        type="checkbox"
                        onChange={args =>
                          this.toggleFilter({
                            ...args,
                            filterType: "locations",
                          })}
                        columns={1}
                      />
                    </SidebarSection>}

                  {this.state.renderMap &&
                    this.props.mapCenter &&
                    poiLocations.length > 0 &&
                    <SidebarSection contentType="map" modifier="map">
                      <InteractiveMap
                        center={this.props.mapCenter.slice(0).reverse()}
                        places={poiLocations}
                        hideCenterPin
                        hideZoomControls
                        markerClick={(event, poi) => {
                          this.markerClick(event, poi, params);
                        }}
                        height={kind === "sleeping" ? 432 : 618}
                        mode={this.mapMode}
                        fitBounds
                      />
                    </SidebarSection>}
                </Sticky>
              </aside>}

            <article className="PageArticle">
              <header className="PageArticle-header">
                <TypeSelector
                  title={type.title}
                  menuItems={menuItems}
                  mobile={mobile.isMobile}
                />

                {!mobile.isMobile &&
                  type.showCurrency &&
                  <div style={styles.header.dropdown.desktop}>
                    <Dropdown
                      options={["AUD", "EUR", "GBP", "USD"]}
                      defaultValue={this.state.currency}
                      onChange={event => {
                        this.setState({
                          currency: event.currentTarget.value,
                        });
                      }}
                    />
                  </div>}

                {mobile.isMobile &&
                  <Sticky
                    enabled={mobile.isMobile}
                    top={0}
                    bottomBoundary=".PageContent"
                    innerZ={zIndex.default + 1}
                  >
                    <Style
                      scopeSelector=".PageArticle-header"
                      rules={{
                        ".active .MobileToolbar": {
                          borderTopColor: `${color.white} !important`,
                          borderBottom: `1px solid ${color.gray}`,
                          marginTop: 0,
                          transition: `border-top-color ${timing.fast}`,
                        },
                      }}
                    />

                    <MobileToolbar
                      selectedDates={this.state.dateRangeString}
                      location={breadcrumb[breadcrumb.length - 1].title}
                      locationUrl={breadcrumb[breadcrumb.length - 1].href}
                      style={
                        pois.length === 0 && {
                          borderBottom: `1px solid ${color.gray}`,
                        }
                      }
                    >
                      {this.state.renderMap &&
                        this.props.mapCenter &&
                        <div>
                          <Button
                            color="white"
                            size="small"
                            onClick={() =>
                              this.handleToolbarClick(
                                constants.OPEN_MAP_TAKEOVER
                              )}
                            customStyles={styles.mobile.toolbar}
                          >
                            Map
                          </Button>

                          <Takeover
                            title={type.title}
                            mobile={mobile.isMobile}
                            closeOnHeaderClick
                            contentFill
                            hasOverlay
                            cover
                            isOpened={
                              mobile.openTakeover ===
                              constants.OPEN_MAP_TAKEOVER
                            }
                            dispatch={this.props.dispatch}
                          >
                            <InteractiveMap
                              center={this.props.mapCenter.slice(0).reverse()}
                              places={this.state.pois}
                              hideCenterPin
                              fill
                              markerClick={(event, poi) => {
                                this.markerClickMobile(event, poi, params);
                              }}
                              markerSize={[25, 25]}
                              mode="explore"
                              hideZoomControls
                              panToCenter
                              fitBounds
                            />
                          </Takeover>
                        </div>}

                      {subtypes &&
                        <div>
                          <Button
                            color="white"
                            size="small"
                            onClick={() =>
                              this.handleToolbarClick(
                                constants.OPEN_FILTER_TAKEOVER
                              )}
                            customStyles={styles.mobile.toolbar}
                          >
                            Filter
                          </Button>

                          <Takeover
                            title="Filter"
                            mobile={mobile.isMobile}
                            closeOnHeaderClick
                            hasOverlay
                            cover
                            scroll
                            isOpened={
                              mobile.openTakeover ===
                              constants.OPEN_FILTER_TAKEOVER
                            }
                            dispatch={this.props.dispatch}
                          >
                            {(this._isTour() || this._isActivity()) && sliders}

                            {this._isLodging() &&
                              <Booking
                                type="hotel"
                                startDate={availability.startDate}
                                endDate={availability.endDate}
                                filter
                                onSelectDates={this.onSelectDates}
                                getPriceOnLoad={
                                  availability.startDate && availability.endDate
                                }
                              />}

                            {this._isLodging() &&
                              availability.startDate &&
                              availability.endDate &&
                              lodgingSliders}

                            {ListComponent._isRestaurant() &&
                              <SidebarSection title="Price">
                                <Filter
                                  filters={["$", "$$", "$$$"]}
                                  type="checkbox"
                                  columns={3}
                                />
                              </SidebarSection>}

                            {subtypes.length > 0 &&
                              <SidebarSection title="Type">
                                <Filter
                                  filters={subtypes}
                                  type="checkbox"
                                  onChange={args =>
                                    this.toggleFilter({
                                      ...args,
                                      filterType: "subtypes",
                                    })}
                                  onSelectNone={() => {
                                    this.toggleFilter({ reset: "subtypes" });
                                  }}
                                />
                              </SidebarSection>}

                            {this._isLodging() &&
                              <SidebarSection noMargin>
                                <Filter
                                  filters={lpReview}
                                  type="checkbox"
                                  onChange={args =>
                                    this.toggleFilter({
                                      ...args,
                                      filterType: "exists",
                                    })}
                                  columns={1}
                                  noMargin
                                />
                              </SidebarSection>}

                            {this._isLodging() &&
                              <SidebarSection title="Amenities">
                                <Filter
                                  filters={facilities}
                                  type="checkbox"
                                  onChange={args =>
                                    this.toggleFilter({
                                      ...args,
                                      filterType: "facilities",
                                    })}
                                  columns={2}
                                  space
                                />
                              </SidebarSection>}

                            {neighborhoods.length > 0 &&
                              !this._isTour() &&
                              !this._isActivity() &&
                              <SidebarSection title="Neighborhoods">
                                <Filter
                                  filters={neighborhoods}
                                  type="checkbox"
                                  onChange={args =>
                                    this.toggleFilter({
                                      ...args,
                                      filterType: "locations",
                                    })}
                                  columns={1}
                                />
                              </SidebarSection>}
                          </Takeover>
                        </div>}
                    </MobileToolbar>
                  </Sticky>}
              </header>

              <div className="PageArticle-content" style={loadingStyle}>
                {!loading &&
                  pois.length === 0 &&
                  <NoResults
                    onReset={() => {
                      this.rangeFilter({ reset: true });
                      this.resetDates();
                      this.toggleFilter({ reset: "all" });
                    }}
                    style={{
                      borderTop: !mobile.isMobile && `1px solid ${color.gray}`,
                      paddingTop: "35px",
                    }}
                  />}

                <ListItems
                  pois={pois}
                  type={type}
                  params={params}
                  adWrapperStyle={adWrapperStyle}
                  breadcrumbs={breadcrumb}
                  mapMode={this.mapMode}
                  mobile={mobile.isMobile}
                  fetchingNext={fetchingNext}
                  onShowPrices={this.showListPrices}
                  favorites={this.props.favorites}
                  lpCurrency={Cookies.get("lpCurrency") || "USD"}
                />
              </div>

              <Waypoint
                onEnter={this._handleWaypointEnter}
                bottomOffset={"-50%"}
              />
            </article>
          </div>
        </div>
      </div>
    );
  }
}

const getResource = (state, props) => RESOURCE_MAP[props.params.resource];
const getKind = (state, props) => RESOURCE_KIND_MAP[props.params.kind];
const getSubtypesFromState = state => state.subtypes;

const getSubtypesWithResource = createSelector(
  [getSubtypesFromState, getResource],
  (subtypes, resource) => getSubtypes(subtypes, resource)
);

const facilities = getFacilities();

const getFavorites = state => {
  const { bookmarks } = state.bookmarkLists;

  if (!bookmarks) {
    return {};
  }

  return Object.keys(bookmarks).reduce((m, b) => {
    m[bookmarks[b].target.id] = bookmarks[b].target;
    return m;
  }, {});
};

const mapStateToProps = (state, props) => ({
  facilities,
  userAgent: state.userAgent,
  pois: uniquePois(state.list.items),
  mobile: state.mobile,
  mapCenter: mapCenter(state.list.items),
  nextPoisLink: state.list.next,
  breadcrumb: state.breadcrumb,
  subtypes: getSubtypesWithResource(state, props),
  loading: state.loading,
  place: state.place,
  availability: getAvailability(state.availability),
  fetchingNext: state.fetchingNext,
  filters: state.filters,
  resource: getResource(state, props),
  kind: getKind(state, props),
  queryStringFilters: props.location.query,
  favorites: getFavorites(state),
  images: Array.prototype.concat(...state.list.items.map(item => item.images)),
});

const connected = connect(mapStateToProps)(ListComponent);
export { connected };



// WEBPACK FOOTER //
// ./assets/list/components/list.jsx